import { AfterViewInit, Component, inject, OnInit, Renderer2 } from '@angular/core';
import { LocalStorageService } from '@proman/services/local-storage.service';
import { TranslateService } from '@ngx-translate/core';
import { PreferencesService } from '@proman/services/preferences.service';
import {
    OPTIONS_FONT_SIZE,
    OPTIONS_STYLE,
    UI_POS2_SIDEBAR_ON_BOTTOM,
    UI_SHOW_REQUEST_LOADER
} from "@pos-shared/options";
import { getPendingRequests } from '@proman/store/utils';
import { debounceTime } from "@proman/rxjs-common";
import { Observable } from 'rxjs';
import { isDefinedNotNull, isNull } from "@proman/utils";
import { Store } from '@ngrx/store';
import { AppInitService } from "@proman/services/app-init.service";
import { loadPosOptionsOverrides } from '@pos-shop-shared/store';
import { NavigationEnd, Router } from '@angular/router';

@Component({
    selector: 'pos2-app',
    template: `
        <div class="App-buffer-container"
             [ngClass]="{
                'VisibilityHidden': (isPendingRequests$ | async) < 1,
                'DisplayNone': !showRequestLoader
            }"
        >
            <mat-progress-bar mode="indeterminate" color="accent"></mat-progress-bar>
        </div>
        <router-outlet></router-outlet>

    `,
    styles: [`
        .App-buffer-container {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 4px;
            z-index: 2;
        }
    `]

})
export class AppComponent implements OnInit, AfterViewInit {
    isPendingRequests$: Observable<number>;
    showRequestLoader: boolean;
    Router = inject(Router);

    constructor(
        private LocalStorage: LocalStorageService,
        private Translate: TranslateService,
        private Prefs: PreferencesService,
        private Render2: Renderer2,
        private store: Store,
        private AppInit: AppInitService,
    ) {
        this.store.dispatch(loadPosOptionsOverrides());
        this.Translate.use(this.AppInit.currentLang);
        const fontSize = this.LocalStorage.getItem(OPTIONS_FONT_SIZE);

        if (fontSize) {
            if (fontSize === 'bold') {
                this.Render2.removeStyle(document.querySelector('html'), 'font-size');
                this.Render2.addClass(document.querySelector('body'), 'bold-font');
            } else {
                this.Render2.setStyle(document.querySelector('html'), 'font-size', fontSize);
                this.Render2.removeClass(document.querySelector('body'), 'bold-font');
            }
        }

        const style = window.localStorage.getItem(OPTIONS_STYLE) || 'default';          //Kazkodel nepaima stiliaus reiksmes

        this.Render2.addClass(document.querySelector('html'), style);

        this.isPendingRequests$ = this.store.select(getPendingRequests)
            .pipe(debounceTime(25));

        this.checkLoaderRequestValue();

        this.LocalStorage.onUpdate.subscribe(() => {
            this.checkLoaderRequestValue();
        });

        this.Prefs.resize$.subscribe(() => {
           this.calcHeight();
        });

        this.checkBottomFooter();

        this.Router.events.subscribe((ev) => {
            if (ev instanceof NavigationEnd) {}

        })
    }

    ngOnInit() {

    }

    ngAfterViewInit() {
        this.calcHeight();
    }

    checkLoaderRequestValue() {
        let storedShowLoaderValue = this.LocalStorage.getItem(UI_SHOW_REQUEST_LOADER);

        if (!isDefinedNotNull(storedShowLoaderValue)) {
            storedShowLoaderValue = true;
            this.LocalStorage.setItem(UI_SHOW_REQUEST_LOADER, true);
        }

        this.showRequestLoader = storedShowLoaderValue;
    }

    calcHeight() {
        const pos2HeaderHeight = 48;

        const root = document.querySelector(':root') as HTMLElement;

        root.style
            .setProperty('--pos2-height-no-header', `${Math.floor(window.innerHeight - pos2HeaderHeight)}px`);
        root.style
            .setProperty('--pos2-height', `${Math.floor(window.innerHeight)}px`);
    }

    checkBottomFooter() {
        if (isNull(this.LocalStorage.getItem(UI_POS2_SIDEBAR_ON_BOTTOM))) {
            this.LocalStorage.setItem(UI_POS2_SIDEBAR_ON_BOTTOM, true);
        }

    }

}

